export default __webpack_public_path__ + "static/media/default-profile-image.1d0c42d3.png";